import {useIntl} from 'react-intl'
import {useCustomerId, useShopperCustomersMutation} from '@salesforce/commerce-sdk-react'

import {useToast} from '@salesforce/retail-react-app/app/hooks/use-toast'
import {useWishList} from '../hooks/use-wish-list'
import {useGtm} from '../integrations/gtm/app/hooks/use-gtm'
import useSegment from '../integrations/segment/app/hooks/use-segment'
import {useTrackThinkAnalyticsEvents} from './use-track-thinkanalytics-events'

import {
    API_ERROR_MESSAGE,
    TOAST_MESSAGE_REMOVED_FROM_WISHLIST,
    TOAST_MESSAGE_ADDED_TO_GUEST_WISHLIST
} from '../constants'

export const useWishlistActions = () => {
    const {data: wishlist} = useWishList()
    const customerId = useCustomerId()
    const segment = useSegment()
    const {formatMessage} = useIntl()
    const {mutate: trackTAEvent} = useTrackThinkAnalyticsEvents()
    const toast = useToast()
    const gtm = useGtm()

    const {mutateAsync: createCustomerProductListItem} = useShopperCustomersMutation(
        'createCustomerProductListItem'
    )
    const {mutateAsync: deleteCustomerProductListItem} = useShopperCustomersMutation(
        'deleteCustomerProductListItem'
    )

    const addItemToWishlist = async (product, index, productDetail, event, useCase) => {
        try {
            const wishListId = wishlist?.productWishList?.find((item) => item?.id)?.id
            await createCustomerProductListItem({
                parameters: {customerId, listId: wishListId},
                body: {
                    quantity: 1,
                    public: false,
                    priority: 1,
                    type: 'product',
                    productId: product?.productId || product?.id
                }
            })

            toast({
                title: formatMessage(TOAST_MESSAGE_ADDED_TO_GUEST_WISHLIST),
                status: 'success',
                duration: 3000
            })
            trackTAEvent({
                c_productId: product?.productId || product?.id,
                c_refUseCase: useCase && useCase,
                c_useCase: 'Store%2FLearn%2FClickedOnSearch'
            })

            // gtm
            gtm.sendProductToWishList('addToWishlist', product)

            // segment
            segment.sendProductToWishList(product, wishlist, index, productDetail, event)
        } catch (e) {
            toast({
                title: formatMessage(API_ERROR_MESSAGE),
                status: 'error',
                duration: 3000
            })
        }
    }

    const removeItemFromWishlist = async (product, index, productDetail) => {
        try {
            const listId = wishlist.productWishList?.find((item) => item?.id)?.id
            const itemId = wishlist?.productWishList
                ?.flatMap((list) => list.customerProductListItems || [])
                .find((item) => item.productId === (product?.productId || product?.id))?.id

            await deleteCustomerProductListItem({
                body: {},
                parameters: {customerId, listId, itemId}
            })

            toast({
                title: formatMessage(TOAST_MESSAGE_REMOVED_FROM_WISHLIST),
                status: 'error'
            })
            // segment
            segment.sendRemoveProductFromWishlist(product, wishlist, index, productDetail)
        } catch (e) {
            toast({
                title: formatMessage(API_ERROR_MESSAGE),
                status: 'error'
            })
        }
    }

    return {addItemToWishlist, removeItemFromWishlist}
}
